import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const ADMIN_API = `${BACKEND_URL}/api`;
export const ADMIN_TOKEN_KEY = "silky_admin_token";
export const ADMIN_EXPIRY_KEY = "silky_admin_expires_at";

export const adminApi = axios.create({
  baseURL: ADMIN_API,
  headers: { "Content-Type": "application/json" },
});

adminApi.interceptors.request.use((config) => {
  const token = readAdminToken();
  if (token) {
    config.headers["x-admin-token"] = token;
  }
  return config;
});

export function readAdminToken() {
  const token = localStorage.getItem(ADMIN_TOKEN_KEY);
  const expiry = localStorage.getItem(ADMIN_EXPIRY_KEY);
  if (!token || !expiry) return null;
  if (new Date(expiry).getTime() < Date.now()) {
    clearAdminToken();
    return null;
  }
  return token;
}

export function persistAdminToken(token, expiresAt) {
  localStorage.setItem(ADMIN_TOKEN_KEY, token);
  localStorage.setItem(ADMIN_EXPIRY_KEY, expiresAt);
}

export function clearAdminToken() {
  localStorage.removeItem(ADMIN_TOKEN_KEY);
  localStorage.removeItem(ADMIN_EXPIRY_KEY);
}

export function formatAdminError(err, fallback = "Something went wrong.") {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return (
      detail
        .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
        .filter(Boolean)
        .join(" · ") || fallback
    );
  }
  if (detail && typeof detail === "object") {
    if (typeof detail.msg === "string") return detail.msg;
    return JSON.stringify(detail);
  }
  return String(detail);
}

export function absolutePhotoUrl(url) {
  if (!url) return null;
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
}
